import { action, observable } from 'mobx';
import { HttpClient, setMap } from 'Mri.Web.Common';

export class PartDefinitionsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAllTopLevelAsync() {
        const partDefinitions = await this.httpClient.get<Mri.Parts.PartDefinition[]>(
            `/api/v1/part-definitions/top-level`
        );

        setMap(this.topLevelPartDefinitions, partDefinitions, m => m.partNumber);
    }

    @action
    public async loadAllAsync() {
        const partDefinitionBases = await this.httpClient.get<Mri.Parts.PartDefinitionBase[]>(
            `/api/v1/part-definitions`
        );

        setMap(this.partDefinitionBases, partDefinitionBases, p => p.partNumber);
    }

    @action
    public async createAsync(model: Mri.Parts.PartDefinitionBase) {
        const partDefinitionBase = await this.httpClient.post<Mri.Parts.PartDefinitionBase>(
            `/api/v1/part-definitions`,
            model
        );

        if (partDefinitionBase) this.partDefinitionBases.set(partDefinitionBase.partNumber, partDefinitionBase);
    }

    @action
    public async updateAsync(partNumber: string, model: Mri.Parts.PartDefinitionBase) {
        const partDefinitionBase = await this.httpClient.put<Mri.Parts.PartDefinitionBase>(
            `/api/v1/part-definitions/${partNumber}`,
            model
        );

        if (partDefinitionBase) this.partDefinitionBases.set(partDefinitionBase.partNumber, partDefinitionBase);
    }

    @action
    public async createRevisionAsync(model: Mri.Parts.PartDefinition) {
        const partDefinition = await this.httpClient.post<Mri.Parts.PartDefinition>(
            `/api/v1/part-definitions/revision`,
            model
        );

        if (partDefinition) {
            const partDefinitionBase = this.partDefinitionBases.get(partDefinition.partNumber);
            partDefinitionBase?.partDefinitions.push(partDefinition);
        }
    }

    @observable public partDefinitionBases = new Map<string, Mri.Parts.PartDefinitionBase>();
    @observable public topLevelPartDefinitions = new Map<string, Mri.Parts.PartDefinition>();

    private readonly httpClient: HttpClient;
}
